export const sizeClasses = {
  sm: 'h-6 w-6 text-xs',
  md: 'h-8 w-8 text-xs',
  lg: 'h-10 w-10 text-sm',
  xs: 'h-4 w-4 text-xs',
};
const colorVariants = [
  'bg-red-500 text-white',
  'bg-blue-500 text-white',
  'bg-green-500 text-white',
  'bg-yellow-500 text-black',
  'bg-purple-500 text-white',
  'bg-pink-500 text-white',
  'bg-indigo-500 text-white',
  'bg-teal-500 text-white',
  'bg-orange-500 text-white',
  'bg-cyan-500 text-white',
];
export function getInitials(
  userName?: string,
  loginName?: string,
  userId?: string | number,
): string {
  if (userName) {
    return userName
      .split(' ')
      .map((name) => name.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }

  if (loginName) {
    return loginName.charAt(0).toUpperCase();
  }

  if (userId) {
    return `U${userId}`;
  }

  return 'U';
}
function getDeterministicColor(input: string): string {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }

  const index = Math.abs(hash) % colorVariants.length;
  return colorVariants[index];
}

export function getUserColorClass(recnum: string | number): string {
  return getDeterministicColor(recnum?.toString() || 'default');
}
